// Vendor imports
const _ = require('lodash')
const React = require('react')
const PropTypes = require('prop-types')
// Browser-specific vendor imports
let Stickyfill
if (typeof window === 'object') {
  Stickyfill = require('stickyfill')()
}
// Shared imports
const BemEntity = require('shared/bem')
// Common Client V2 imports
const ArticleCard = require('client-v2/common/components/cards/article')
const CollectionCard = require('client-v2/common/components/cards/collection')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

const bem = BemEntity('TopCallToActionSection')

const THROTTLE_FREQUENCY = 66 // ~15 frames per second

class TopCallToActionSection extends React.PureComponent {
  constructor(props) {
    super(props)

    this.leadingContainerRef = React.createRef()
    this.explainerContainerRef = React.createRef()
    this.onFoldHeightChange = _.throttle(this.onFoldHeightChange.bind(this), THROTTLE_FREQUENCY)
  }

  componentDidMount() {
    if (typeof window === 'object') {
      // Polyfill for missing `position: sticky` support in Internet Explorer 11
      Stickyfill.add(this.explainerContainerRef.current)
      window.addEventListener('resize', this.onFoldHeightChange)
      this.onFoldHeightChange()
    }
  }

  componentWillUnmount() {
    if (typeof window === 'object') {
      Stickyfill.remove(this.explainerContainerRef.current)
      window.removeEventListener('resize', this.onFoldHeightChange)
    }
  }

  onFoldHeightChange() {
    this.props.onFoldHeightChange(this.leadingContainerRef.current.scrollHeight)
  }

  renderExplainer() {
    return (
      tag('div', {
        className: bem.element('explainer-container'),
        ref: this.explainerContainerRef
      },
        tag('div', {
          className: bem.element('explainer-heading')
        },
          `All your favorite things.`,
          tag('br'),
          `All in one place.`
        ),
        tag('div', {
          className: bem.element('explainer-subheading')
        },
          `Curate and share the best of the internet.`,
          tag('br'),
          `Mix learns what you love to show you even more.`
        ),
        this.renderButtons()
      )
    )
  }

  renderButtons() {
    return (
      tag('div', {
        className: bem.element('buttons-container')
      },
        tag('button', {
          className: bem.element('button', 'primary'),
          onClick: (
            this.props.isSULandingPage
              ? this.props.onSULoginClick
              : this.props.onSignupClick
          )
        },
          `Join Mix`
        ),
        !this.props.isSULandingPage &&
          tag('button', {
            className: bem.element('button', 'secondary'),
            onClick: this.props.onLoginClick
          },
            `Sign in`
          )
      )
    )
  }

  renderCollectionCard() {
    return (
      tag('div', {
        className: bem.element('card-container', 'collection')
      },
        tag(CollectionCard, {
          className: bem.element('card', 'collection'),
          // Flags
          isHrefsEnabled: false,
          // Values
          collection: this.props.collection,
          placeholderImage: this.props.placeholderImage,
          // Callbacks
          onFollowClick: this.props.onSignupClick
        }),
        tag('div', {
          className: bem.element('card-heading', 'collection')
        },
          `Follow and create`,
          tag('br'),
          `collections you love.`
        )
      )
    )
  }

  renderArticleCard() {
    return (
      tag('div', {
        className: bem.element('card-container', 'article')
      },
        tag(ArticleCard, {
          className: bem.element('card', 'article'),
          // Flags
          isHrefsEnabled: false,
          // Values
          article: this.props.article,
          placeholderImage: this.props.placeholderImage,
          // Callbacks
          onAddClick: this.props.onSignupClick
        }),
        tag('div', {
          className: bem.element('card-heading', 'article')
        },
          `Articles, images, videos, music.`
        ),
        tag('div', {
          className: bem.element('card-subheading', 'article')
        },
          `
            Save anything, from anywhere.
            If it's on the internet, you can add it to Mix.
          `
        )
      )
    )
  }

  render() {
    return (
      tag('div', {
        className: bem.block()
      },
        // Leading container
        tag('div', {
          className: bem.element('leading-container'),
          ref: this.leadingContainerRef
        },
          this.renderExplainer()
        ),
        // Trailing container
        tag('div', {
          className: bem.element('trailing-container')
        },
          this.renderCollectionCard(),
          this.renderArticleCard()
        )
      )
    )
  }
}

TopCallToActionSection.propTypes = {
  // Flags
  isSULandingPage: PropTypes.bool.isRequired,
  // Values
  article: PropTypes.shape({
    description: PropTypes.string.isRequired,
    hostname: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired,
  collection: PropTypes.shape({
    images: PropTypes.arrayOf(PropTypes.string).isRequired,
    name: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired
  }).isRequired,
  placeholderImage: PropTypes.string.isRequired,
  // Callbacks
  onFoldHeightChange: PropTypes.func.isRequired,
  onLoginClick: PropTypes.func.isRequired,
  onSignupClick: PropTypes.func.isRequired,
  onSULoginClick: PropTypes.func.isRequired
}

module.exports = TopCallToActionSection
